
const digest = 'cc84367debd3a2d782f7fcc5a0902348b33a3747b34a0fac9f6cdc80f4c2ca11';
const classes = {"invoicingDetails":"_invoicingDetails_1w7ed_1","left":"_left_1w7ed_9","right":"_right_1w7ed_17","attachmentNumber":"_attachmentNumber_1w7ed_25","invoices":"_invoices_1w7ed_30","state":"_state_1w7ed_36","sent":"_sent_1w7ed_39","commission":"_commission_1w7ed_43","stripeButtonWrapper":"_stripeButtonWrapper_1w7ed_47"};
const css = `._invoicingDetails_1w7ed_1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 16px;
  align-items: center;
}
._invoicingDetails_1w7ed_1 ._left_1w7ed_9 {
  display: flex;
  flex-direction: row;
}
._invoicingDetails_1w7ed_1 ._left_1w7ed_9 > * {
  margin-left: 16px;
  margin-bottom: 16px;
}
._invoicingDetails_1w7ed_1 ._right_1w7ed_17 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  padding: 0 12px;
}

._attachmentNumber_1w7ed_25 {
  color: #2867d9;
  text-decoration: underline;
}

._invoices_1w7ed_30 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

._state_1w7ed_36 {
  font-weight: 500;
}
._state_1w7ed_36._sent_1w7ed_39 {
  color: #f39a3a;
}

._commission_1w7ed_43 {
  color: #619611;
}

._stripeButtonWrapper_1w7ed_47 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 10px 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  